import { cn } from "@/lib/utils";

interface GlobalLoaderProps {
  isLoading?: boolean;
  className?: string;
}

export function GlobalLoader({ isLoading = true, className }: GlobalLoaderProps) {
  if (!isLoading) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm",
        className
      )}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="h-12 w-12 rounded-full border-4 border-blue-500/30" />
          <div className="absolute inset-0 h-12 w-12 animate-spin rounded-full border-4 border-transparent border-t-blue-500" />
        </div>
      </div>
    </div>
  );
}
